var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Email Address"}},[_c('input-text',{staticClass:"w-full",attrs:{"name":"email","value":_vm.broker.email,"placeholder":"Email","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }